<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <v-col>
                <v-card max-height="400" class="pa-3">
                    <v-card-text>
                        <v-img src="@/assets/kumapeko1.png" contain max-height="200" aspect-ratio="1" />
                        <table style="width:100%; text-align:center">
                            <tr>
                                <td>
                                    現在、圃場管理システムのメンテナンス中です。<br/>
                                    終了予定は {{systemState.data.to}} を予定しております。
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <v-btn color="primary" class="ma-2" @click="onClickLogin">ログイン</v-btn>
                                </td>
                            </tr>
                        </table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            systemState: null
        },
        methods: {
            onClickLogin: function () {
                window.location.reload()
            }
        }
    }
</script>